import React from 'react';
import { Box, Paper, Typography, alpha, useTheme } from '@mui/material';

const PageHeader = ({ title, subtitle }) => {
  const theme = useTheme();
  
  return (
    <Paper 
      elevation={0}
      sx={{
        mb: 6,
        p: 4,
        borderRadius: 3,
        background: `linear-gradient(45deg, ${theme.palette.primary.main} 0%, ${alpha(theme.palette.primary.main, 0.8)} 100%)`,
        color: 'white',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <Box sx={{
        position: 'absolute',
        top: -30,
        right: -30,
        width: 200,
        height: 200,
        borderRadius: '50%',
        background: alpha('#ffffff', 0.1)
      }} />
      
      <Box sx={{
        position: 'absolute',
        bottom: -40,
        left: -40,
        width: 150,
        height: 150,
        borderRadius: '50%',
        background: alpha('#ffffff', 0.05)
      }} />
      
      <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 1, position: 'relative', zIndex: 1 }}>
        {title}
      </Typography>
      
      {subtitle && (
        <Typography variant="subtitle1" sx={{ opacity: 0.8, position: 'relative', zIndex: 1 }}>
          {subtitle}
        </Typography>
      )}
    </Paper>
  );
};

export default PageHeader;
